import reducer from '../reducers/reducer';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import {reducer  as toastrReducer} from 'react-redux-toastr';

export const browserHistory = createHistory();
const middleware = routerMiddleware(browserHistory)

export const store = createStore(
  combineReducers({
    reducer,
    router: routerReducer,
    toastr: toastrReducer
  }),
  applyMiddleware(middleware)
);


// WEBPACK FOOTER //
// ./src/Store/store.js